import stylesheet from './StoryCardList.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTStoryCardList extends CustomComponent {

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add('story-card-list');

        const cards = document.createElement('div');
        cards.classList.add('story-cards', 'layout-list');
        cards.innerHTML = `<slot></slot>`;

        const cta = document.createElement('div');
        cta.classList.add('cta');
        this.cloneSlotContentIntoContainer(cta, 'cta');

        container.appendChild(cards);
        container.appendChild(cta);
        return container;
    }

    connectedCallback() {
        super.connectedCallback();
    }
}

customElements.define('nxt-story-card-list', NXTStoryCardList);
